var _path, _path2, _circle, _path3, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUec(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56 35",
    style: {
      enableBackground: "new 0 0 56 35"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M52,0H4C1.8,0,0,1.8,0,4v27c0,2.2,1.8,4,4,4h48c2.2,0,4-1.8,4-4V4C56,1.8,54.2,0,52,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F9FC",
    d: "M52,35H4c-2.2,0-4-1.8-4-4V4c0-2.2,1.8-4,4-4h48c2.2,0,4,1.8,4,4v27C56,33.2,54.2,35,52,35z M4,1 C2.3,1,1,2.3,1,4v27c0,1.7,1.3,3,3,3h48c1.7,0,3-1.3,3-3V4c0-1.7-1.3-3-3-3H4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Logo_3_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 14.3577,
    y1: 30.7694,
    x2: 40.3577,
    y2: 6.2694,
    gradientTransform: "matrix(1 0 0 -1 0 35.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D7D7D7"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#Logo_3_1_)",
    cx: 27.6,
    cy: 17.6,
    r: 12.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#004B91",
    d: "M38.3,14.2c0,6.1-5.5,8.6-8.7,8.6c-2.4,0-3.8-0.9-4.2-1.2c2.3,0.2,7,0.2,7-4c0-5.2-8.5-8-13.2-2 c-3,3.9-1.7,8.2,0,10.8c0.3-0.2,0.7-0.3,1.1-0.3c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2c-1.1,0-2-0.9-2-2c0-0.6,0.3-1.1,0.6-1.4 c-2.4-2.3-3.8-5.5-3.8-9C15,10.6,20.6,5,27.6,5C32.5,5,38.3,8.2,38.3,14.2z M44.1,27l-0.9,1.9L42.1,27H41l1.7,2.8L42,30.9H43 l2.1-3.9H44.1z M50,28.8l1.9-1.8h-1.1l-1.7,1.7V27h-0.8v3.9h0.8v-1.7l0.1-0.1l1.6,1.8H52L50,28.8z M45.9,27h-0.6l-0.6,1 c0.1-0.1,0.4-0.4,1.1-0.4c0.8,0,1.3,0.5,1.3,1h-2v0.7h2c0,0.5-0.6,1-1.3,1c-0.6,0-1.1-0.2-1.3-0.4v0.8c0,0,0.4,0.2,1.3,0.2 c1.2,0,2.2-0.7,2.2-2.1S46.9,27,45.9,27z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#E15E37",
    cx: 27.6,
    cy: 17.6,
    r: 4.7
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUec);
export default __webpack_public_path__ + "static/media/uec.592c75a5.svg";
export { ForwardRef as ReactComponent };